var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLanguageRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 124,
    viewBox: "0 0 208 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.169 123.063H194.969V106.463H145.169V123.063Z",
    fill: "#364FC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.106 106.465L197.176 106.465V99.8248L134.106 99.8248V106.465Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.43 106.46V123.06",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.86 99.8203V106.46",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.65 99.8203V106.46",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.061 99.8203V106.46",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.22 106.46V123.06",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.49 106.46V123.06",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.7 106.46V123.06",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.954 99.8242H191.645V92.9142H142.954V99.8242Z",
    fill: "#DBE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.312 92.915H175.192V79.955H136.312V92.915Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.87 79.9502V92.9102",
    stroke: "#364FC7",
    strokeWidth: 1.2036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.39 93.7803V98.9603",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.92 93.7803V98.9603",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.149 79.9502V92.9102",
    stroke: "#364FC7",
    strokeWidth: 1.2036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.91 79.9502V92.9102",
    stroke: "#364FC7",
    strokeWidth: 1.2036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.64 79.9502V92.9102",
    stroke: "#364FC7",
    strokeWidth: 1.2036,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67 31.0198V8.2998H136.13V31.0198L129.68 43.0898L147.16 31.6098H168.36",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13 19.04C155.13 19.04 156.17 26.8 165.09 29",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.09 14.6201C165.09 14.6201 161.77 29.0101 154.58 29.0101",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.43 14.6197C150.43 14.6197 160.66 12.6397 171.73 13.6297",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.73 12.7797C157.73 12.9397 157.73 13.1097 157.73 13.2697C157.72 13.4997 157.77 13.7097 157.87 13.9097C157.94 14.1197 158.05 14.2897 158.21 14.4397C158.36 14.5997 158.54 14.7197 158.74 14.7797C158.94 14.8797 159.15 14.9297 159.38 14.9197C159.53 14.8997 159.67 14.8797 159.82 14.8597C160.1 14.7797 160.35 14.6397 160.55 14.4297C160.64 14.3197 160.72 14.2097 160.81 14.0897C160.96 13.8297 161.04 13.5497 161.04 13.2497C161.04 13.0897 161.04 12.9197 161.04 12.7597C161.05 12.5297 161 12.3197 160.9 12.1197C160.83 11.9097 160.72 11.7397 160.56 11.5897C160.41 11.4297 160.23 11.3097 160.03 11.2497C159.83 11.1497 159.62 11.0997 159.39 11.1097C159.24 11.1297 159.1 11.1497 158.95 11.1697C158.67 11.2497 158.42 11.3897 158.22 11.5997C158.13 11.7097 158.05 11.8197 157.96 11.9397C157.81 12.1997 157.74 12.4797 157.73 12.7797Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7103 27.8301C108.84 27.8001 128.11 44.1701 131.13 66.7101C134.41 91.2401 117.19 113.79 92.6504 117.07C68.1104 120.35 45.5704 103.13 42.2904 78.5901C40.3304 63.9601 45.6704 50.0301 55.5104 40.4701",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7102 27.5098C96.2402 27.5098 103.97 47.5698 103.97 72.3298C103.97 97.0898 96.2402 117.15 86.7102 117.15C77.1802 117.15 69.4502 97.0898 69.4502 72.3298C69.4502 59.9798 71.3702 48.7998 74.4802 40.6998",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4307 27.5098C85.4307 27.5098 120.401 33.0398 120.401 69.5598C120.401 110.5 87.6406 117.14 87.6406 117.14",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4305 41.5498C56.2305 47.8298 52.2305 56.8098 52.2305 69.5598C52.2305 110.5 84.9905 117.14 84.9905 117.14",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6007 27.5098C105.161 27.5098 122.121 38.6598 122.121 52.4098C122.121 66.1598 106.271 77.3098 86.7107 77.3098C67.1507 77.3098 51.3008 66.1598 51.3008 52.4098C51.3008 48.1098 52.8507 44.0698 55.5707 40.5398",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.911 65.6895C130.911 83.1095 111.091 97.2295 86.6506 97.2295C62.2106 97.2295 42.3906 83.1095 42.3906 65.6895",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.1 86.8098C123.68 99.8698 106.73 109.39 86.6504 109.39C66.4604 109.39 49.4204 99.7598 44.1104 86.5898",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.71 27.5098C101.16 27.5098 112.88 34.4498 112.88 42.9998C112.88 51.5498 101.16 58.4898 86.71 58.4898C72.26 58.4898 60.54 51.5498 60.54 42.9998",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.6 27.5098C95.09 27.5098 103.89 30.9798 103.89 35.2598C103.89 39.5398 96.2 42.9998 86.71 42.9998C83.84 42.9998 81.13 42.6798 78.75 42.1198",
    stroke: "#91A7FF",
    strokeWidth: 1.1066,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8809 26.8995C85.8809 18.6795 76.5909 12.0195 65.1309 12.0195C53.6709 12.0195 44.3809 18.6795 44.3809 26.8995C44.3809 35.1195 53.6709 41.7795 65.1309 41.7795C68.0309 41.7795 70.7909 41.3495 73.3009 40.5795L79.2509 44.4895L78.0109 38.5595C82.8009 35.8395 85.8809 31.6295 85.8809 26.8995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3409 23.2996C60.6909 21.8896 62.741 21.1796 65.421 21.1796C69.011 21.1796 71.0809 23.2796 71.0809 26.9196V35.2896H67.231V34.0396C66.591 34.7796 65.111 35.4496 63.511 35.4496C60.461 35.4496 58.4609 33.6696 58.4609 30.9396C58.4609 29.4296 59.071 28.3097 60.271 27.5396C61.471 26.7696 62.951 26.3996 64.731 26.3996C65.771 26.3996 66.591 26.5096 67.231 26.7496C67.261 25.3696 66.511 24.7796 65.001 24.7796C63.511 24.7796 62.641 25.0696 61.181 26.1096L59.3409 23.2996ZM62.421 15.8896C63.481 15.8896 64.521 16.6896 64.521 17.7496C64.521 18.8896 63.511 19.6596 62.421 19.6596C61.281 19.6596 60.351 18.9196 60.351 17.7496C60.351 16.6896 61.281 15.8896 62.421 15.8896ZM67.231 30.5496V29.9096C66.621 29.6696 65.901 29.5696 65.131 29.5696C63.351 29.5696 62.4509 30.0196 62.4509 30.9196C62.4509 31.6596 63.141 32.1196 64.311 32.1196C65.581 32.1196 66.781 31.4296 67.231 30.5496ZM67.921 15.8896C69.061 15.8896 70.021 16.6896 70.021 17.7496C70.021 18.9196 69.091 19.6596 67.921 19.6596C66.721 19.6596 65.771 18.9196 65.771 17.7496C65.771 16.6896 66.751 15.8896 67.921 15.8896Z",
    fill: "#5C7CFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4371 114.857C35.707 112.424 38.0404 106.253 35.6488 101.073C33.2572 95.8932 27.0463 93.6668 21.7764 96.1001C16.5065 98.5333 14.1731 104.705 16.5647 109.884C18.9563 115.064 25.1672 117.291 30.4371 114.857Z",
    fill: "#3B5BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4869 113.41C35.7568 110.977 38.0902 104.805 35.6986 99.6256C33.307 94.4459 27.0961 92.2195 21.8262 94.6528C16.5563 97.086 14.2229 103.258 16.6145 108.437C19.0061 113.617 25.217 115.843 30.4869 113.41Z",
    fill: "#91A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5293 107.64C27.1193 108.56 30.8293 106.43 31.8093 102.86",
    stroke: "white",
    strokeWidth: 1.0504,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5768 102.951C21.9078 102.799 22.054 102.411 21.9035 102.085C21.753 101.759 21.3628 101.618 21.0319 101.771C20.7009 101.924 20.5546 102.312 20.7051 102.638C20.8556 102.964 21.2459 103.104 21.5768 102.951Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6188 98.5491C28.9497 98.3963 29.096 98.0082 28.9456 97.6823C28.7951 97.3563 28.4048 97.216 28.0738 97.3688C27.7429 97.5216 27.5966 97.9097 27.7471 98.2356C27.8976 98.5616 28.2879 98.7019 28.6188 98.5491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.551 44.2809L153.367 49.0059L158.092 57.1896L166.276 52.4646L161.551 44.2809Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.431 33.02C197.501 32.61 197.73 32.24 198.09 31.98L201.51 29.59C202.24 29.08 203.24 29.26 203.75 29.99C204.26 30.72 204.08 31.72 203.35 32.23L199.931 34.62C199.201 35.13 198.2 34.95 197.69 34.22C197.44 33.86 197.361 33.42 197.431 33.02Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.92 115.12C206.61 115.12 207.98 113.75 207.98 112.06C207.98 110.37 206.61 109 204.92 109C203.23 109 201.86 110.37 201.86 112.06C201.86 113.75 203.23 115.12 204.92 115.12Z",
    fill: "#748FFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.22 88.5596L188.86 79.6396",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.62 73.3797L173.61 64.6797",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.83 15.7002L118.82 22.5202",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 66.5L0.5 63.5",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 50.5L0.5 29.5",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.6 1.03027L114.58 16.6703",
    stroke: "#748FFC",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageRightImage);
export default __webpack_public_path__ + "static/media/languageRightImage.e29df5a06099993cdadaba69129f1048.svg";
export { ForwardRef as ReactComponent };